module.exports = __webpack_public_path__ + "img/left_img-fba58be9.78506342.png";